import React from "react"
import ExternalIcon from "components/external_icon"

function CCExternalIcon(props) {
  return <ExternalIcon {...props} pathPrefix="/people" />
}

export default CCExternalIcon
